/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
// import styled from 'styled-components';
import { Line } from '@vds/lines';
import { RadioBoxGroup } from '@vds/radio-boxes';
import { TextLink } from '@vds/buttons';

import ShippingTabSection from '../../ShippingTabSection';
import { isMobile as isMobileDevice, isDesktop, isTablet, isShippingTabEnabled, isWHWPhase2Flag } from '../../../../common/Helpers/index';
import { getThrottleKeys } from '../../../../common/Helpers/taggingHelper';
import ShippingPinModal from '../../../../common/Modal/shippingPinVerificationModal';
import { eventDispatcher } from '../../../../common/Tagging/index';
import { saveItemToStore } from '../../../../../utils/sessionStorage';
import { store } from '../../../../../configureStore';
import { PRICE_ZERO, VCS, VAR } from '../../../../../pages/ShippingInfo/Constants';
import { Margin } from '../../../../common/styles';
import { Row } from '../../../../common/FWAContainer';
import Button from '../../../../common/Button';
import { usePrevious } from '../../../../common/hooks';
import { AddressZipCodeValidation } from '../../../../common/addressUtils';
import { ShippingDetailsWrapper } from '../shippingStyles';
import { isIndirectStoresEnabled } from '../../ShippingInfoHelper';

export const ShippingOptions = (props) => {
  const [termsAndConditionsModalVisible, settermsAndConditionsModalVisible] = useState(false);
  const [selectedSlotId, setselectedSlotId] = useState(null);
  const [isSelectedISPU, setIsSelectedISPU] = useState(false);
  const [isIspuDisplay, setIsIspuDisplay] = useState(false);
  const [toggleTileTop, setToggleTileTop] = useState(false);
  const [checkNearestStore, setCheckNearestStore] = useState(false);
  const [estimatedDate, setestimatedDate] = useState(null);
  const [storeArrayNumberFromList, setStoreArrayNumberFromList] = useState(null);
  const selectedOption = props.defaultValue;
  const [selectionBeforeISPU, setselectionBeforeISPU] = useState(null);
  const prevopenISPUModal = usePrevious(props.openISPUModal);
  const ispuSelected = props?.shipmentNewLine?.selectedOptionCode === 'ISPU';
  let prevSelectionBeforeISPU = usePrevious(selectedSlotId);
  if (!prevSelectionBeforeISPU) {
    prevSelectionBeforeISPU = selectedOption;
  }
  const shippingThrottleKeys = getThrottleKeys(props?.cradleResponseDetails, 'FWA_Shipping');
  const hideIspuOption = props?.cradleResponseDetails?.includes('FWA_ISPU_T_Option');
  const renderNearestStore = (item) => {
    if (item === true) {
      setToggleTileTop(true);
      return true;
    }
    setToggleTileTop(false);
    return false;
  };

  let firstTwoStoresNearBy = [];
  if (isIndirectStoresEnabled()) {
    const dStore =
      props?.itemAvailableStores?.length > 0
        ? props?.itemAvailableStores?.filter((i) => i.direct === 'Y')?.sort((a, b) => a.distance - b.distance)
        : [];

    const iStore =
      props?.itemAvailableStores?.length > 0
        ? props?.itemAvailableStores?.filter((i) => i.direct === 'N' && i.distance < props?.milesValue)?.sort((a, b) => a.distance - b.distance)
        : [];
    firstTwoStoresNearBy = [...dStore, ...iStore];
  } else {
    firstTwoStoresNearBy = props?.itemAvailableStores?.length > 0 ? props?.itemAvailableStores?.sort((a, b) => a.distance - b.distance) : [];
  }

  // if store displayed are selected or not from modal
  if (!props.dataSelectedFromISPUModel) {
    firstTwoStoresNearBy = firstTwoStoresNearBy?.slice(0, 2);
  } else if (props.dataSelectedFromISPUModel && isShippingTabEnabled()) {
    firstTwoStoresNearBy = [];
    if (props.ISPUSelectedStoreFromModel) {
      firstTwoStoresNearBy.push(props.ISPUSelectedStoreFromModel);
    }
  }

  // get the nearest store from the available stores
  let isFastestStore;
  if (firstTwoStoresNearBy?.length > 0) {
    isFastestStore = firstTwoStoresNearBy?.[0].distance < props.milesValue;
    if (isFastestStore) {
      if (!checkNearestStore) {
        renderNearestStore(isFastestStore);
        setCheckNearestStore(true);
      }
    }
  }

  // TO CHANGE BOTTOM DIV
  const changePageBottomDivToPickup = (e, index) => {
    // debugger;
    if (index === 1) {
      const var220 = 'FWA_Express_T_Pickup';
      // const var221 ='ep y'
      // console.log("USEEFFECT");
      eventDispatcher('sendData', {
        name: '',
        svars: {
          // evar221: 'AP Toggle Y',
          evar220: var220,
          evar221: shippingThrottleKeys.join('|'),
          evar27: 'express pickup',
        },
      });
      props.changeDivToPickUp(true);
    } else {
      props.changeDivToPickUp(false);
    }
  };

  const mounted = useRef();
  useEffect(() => {
    if (props.storeListUpdatedValue) {
      setCheckNearestStore(false);
      props.updateStoreListValue(false);
    }
  }, [props.storeListUpdatedValue]);

  useEffect(() => {
    const deliveryDate = estimatedDate && new Date(estimatedDate);
    const deliveryDate1 = deliveryDate && `${deliveryDate?.getMonth() + 1}/${deliveryDate?.getDate()}/${deliveryDate?.getFullYear()}`;
    if (deliveryDate1) {
      saveItemToStore('deliveryDate', deliveryDate1);
    }
  }, [estimatedDate]);

  // console.log("SELECTEDSTOREISPU",props.shippingInfoState?.ispuStoreInfo)
  useEffect(() => {
    // TODO Uncomment while pushing
    if (props?.shipmentNewLine?.selectedOptionCode) {
      if (props?.shipmentNewLine?.selectedOptionCode !== 'ISPU') {
        setselectedSlotId(props?.shipmentNewLine?.selectedOptionCode);
      } else if (storeArrayNumberFromList) {
        setselectedSlotId(`ISPU${storeArrayNumberFromList}`);
      } else {
        setselectedSlotId('ISPU');
      }
      // else{
      //   // set selectedSlotId

      // }
    }
    if (!mounted.current) {
      if (!selectedSlotId) {
        return setselectedSlotId[props.defaultValue];
      }
      mounted.current = true;
    } else if (
      (prevopenISPUModal && !props.openISPUModal && !props.shippingInfoState?.ispuStoreInfo) ||
      (isWHWPhase2Flag() && props?.selectOtherOption)
    ) {
      return setselectedSlotId((prevState) => {
        console.log('prevstate', prevState);
        setselectedSlotId(selectionBeforeISPU);
        if (isWHWPhase2Flag() && props?.selectOtherOption) {
          store.dispatch({ type: 'SELECTED_OTHER_SHIPPING' });
          console.log(props.selectOtherOption, 'shubham');
        }
      });
    }
    if (selectedOption === 'ISPU' && !isSelectedISPU) {
      props.selectedShippingOptionValue('ISPU');
      setIsSelectedISPU(true);
    }
  });

  // Update showPickupInfoTab if ISPU selected
  useEffect(() => {
    props.changeDivToPickUp(props?.shippingStoreInfo?.storeName !== undefined);
  }, []);

  const defaultValue = selectedOption;
  const optionsGroupProp = {
    childHeight: isDesktop() ? '100px' : '115px',
    value: selectedSlotId,
    defaultValue,
  };

  // Adding for Dummy Commit

  const isMobile = isMobileDevice();
  const shippingDetails = [];

  const { ispuStoreInfo } = props.shippingInfoState;
  let ispuObj = '';
  let sddObj = '';
  if (props.shipmentNewLine?.shippingOptions) {
    shippingDetails.push(props.shipmentNewLine?.shippingOptions[0]);
    if (props.shipmentNewLine?.shippingOptions[1]) {
      shippingDetails.push(props.shipmentNewLine?.shippingOptions[1]);
    }
    if (props.shipmentNewLine?.shippingOptions[2]) {
      shippingDetails.push(props.shipmentNewLine?.shippingOptions[2]);
    }
    if (props.shipmentNewLine?.shippingOptions[3]) {
      shippingDetails.push(props.shipmentNewLine?.shippingOptions[3]);
    }
  }
  const ispuObjForRedesign = [];
  // shippingDetails.pop();
  // TODO: add Cardle LOGIC

  if (isShippingTabEnabled() && props.isISPUEligible) {
    if (!props.dataSelectedFromISPUModel) {
      ispuObjForRedesign.push({
        shippingOptionId: 'ISPU0',
        shippingCost: 0,
        active: true,
        shippingDescription: 'Availability dependent on store address',
        shippingDescriptionVDSUpgrade: 'Availability dependent on<br>store address',
        name: 'Free In-Store Pickup',
        shortDescription: 'Free In-Store Pickup',
        description: 'Check availability.',
      });
      ispuObjForRedesign.push({
        shippingOptionId: 'ISPU1',
        shippingCost: 0,
        active: true,
        shippingDescription: 'Availability dependent on store address',
        shippingDescriptionVDSUpgrade: 'Availability dependent on<br>store address',
        name: 'Free In-Store Pickup',
        shortDescription: 'Free In-Store Pickup',
        description: 'Check availability.',
      });
    } else {
      ispuObjForRedesign.push({
        shippingOptionId: 'ISPU',
        shippingCost: 0,
        active: true,
        shippingDescription: 'Availability dependent on store address',
        shippingDescriptionVDSUpgrade: 'Availability dependent on<br>store address',
        name: 'Free In-Store Pickup',
        shortDescription: 'Free In-Store Pickup',
        description: 'Check availability.',
      });
    }
    // console.log("OBJECTISPU", ispuObjForRedesign);
    shippingDetails.pop();
  }
  let final = shippingDetails;

  const ISPUStoresClick = () => {
    store.dispatch({ type: 'SET_ISPU_MODAL' });
    // this.setState((prevState) => ({
    // console.log("prevSelectionBeforeISPU", prevSelectionBeforeISPU);
    setselectionBeforeISPU(prevSelectionBeforeISPU);
    setselectedSlotId('ISPU');
    // }));
    const obj = {
      name: 'openIspuModal',
      selector: 'openIspuModalID',
    };
    eventDispatcher('openView', obj);
  };

  if (defaultValue && shippingDetails && shippingDetails.length > 0 && estimatedDate === null) {
    const estimatedDeliveryDate = shippingDetails.filter((opt) => opt.shippingOptionId === defaultValue)?.[0]?.estimatedDeliveryDate || null;
    if (estimatedDeliveryDate) {
      setestimatedDate(estimatedDeliveryDate);
    }
  }

  const showIspu = hideIspuOption ? undefined : shippingDetails.find((i) => i.shippingOptionId === 'ISPU');

  const showSdd = shippingDetails.find((i) => i.shippingOptionId === 'SDD_SAMEDAY');
  if (showSdd !== undefined) {
    sddObj = shippingDetails.filter((i) => i.shippingOptionId === 'SDD_SAMEDAY');
    final = shippingDetails.filter((i) => i.shippingOptionId !== 'SDD_SAMEDAY');
    final.push(sddObj[0]);
  }

  if ((isIspuDisplay || ispuSelected) && showIspu !== undefined) {
    ispuObj = shippingDetails.filter((i) => i.shippingOptionId === 'ISPU');
    final = final.filter((i) => i.shippingOptionId !== 'ISPU');
    final.push(ispuObj?.[0]);
  } else {
    final = final.filter((i) => i.shippingOptionId !== 'ISPU');
  }

  const getOptionData = (shippingData, id, ExpressStoreTab, isISPUSelectedFromModal) => {
    console.log('shippingOptionIdFromgetOptionData', shippingData.shippingOptionId);
    const isISPU = shippingData.shippingOptionId === 'ISPU';
    const isISPUSelected =
      selectedSlotId === shippingData.shippingOptionId && (props.shippingStoreInfo?.storeName || props.shippingStoreInfo?.address1);
    const nonMobileWidth = isDesktop() ? '398px' : 'calc(calc(100% - 12px) / 2)';
    // console.log("")
    const commonProps = {
      width: isMobileDevice() ? '' : nonMobileWidth,
      // ariaLabel: this.getAriaLabel(shippingData, id),
      className: 'shippingOptionWrapper',
      //  isISPUStoreSelectedFromTab
      // eslint-disable-next-line no-useless-concat
      value: ExpressStoreTab && !isISPUSelectedFromModal ? 'ISPU' + `${id}` : isISPUSelectedFromModal ? 'ISPU' : shippingData.shippingOptionId,
    };
    // console.log("commonProps", commonProps.value);
    if (isISPU) {
      let nearestStockedStore = [];
      const storesLst = props?.storeLists;
      let outStores = [];
      if (storesLst && storesLst.length > 0) {
        storesLst.forEach((storeAvailable) => {
          const quanAvl = storeAvailable?.items?.item?.every((item) => item.quantity > 0);
          if (quanAvl) {
            return outStores.push(storeAvailable);
          }
        });
        outStores = outStores?.sort((a, b) => a.distance - b.distance);
        nearestStockedStore = outStores?.[0]?.distance < props?.milesValue;
      }
      const closestInstockStoreDistance = outStores?.[0]?.distance;
      let stockedStore = '';
      if (!checkNearestStore) {
        renderNearestStore(nearestStockedStore);
        setCheckNearestStore(true);
      }
      if (toggleTileTop) {
        stockedStore = `<span className= 'vdsTextGray fontsize_14'>${props?.inStockText}</span>`;
      } else {
        stockedStore = '';
      }
      /** content overflows in Tablet with <br> as the VDS Box height is not fluid */
      const description = isTablet() ? shippingData.shippingDescription : shippingData.shippingDescriptionVDSUpgrade;
      const storeDistance = toggleTileTop
        ? `<div className='fontsize_14'>Within ${closestInstockStoreDistance} miles</div>${stockedStore}`
        : description;
      const ispuTileContent = isISPUSelected && ispuStoreInfo ? `${ispuStoreInfo?.storeName}<br>${ispuStoreInfo?.storeAddress}` : storeDistance || '';

      return {
        ...commonProps,
        id: 'ispuOptionBox',
        text: shippingData.shortDescription,
        subtext: parse(ispuTileContent),
        subtextRight: Number.isNaN(shippingData.shippingCost) ? PRICE_ZERO : `$${parseFloat(shippingData.shippingCost).toFixed(2)}`,
      };
    }
    if (ExpressStoreTab && isShippingTabEnabled()) {
      // debugger;
      if (props?.dataSelectedFromISPUModel) {
        setStoreArrayNumberFromList(null);
      }
      const storeAddress = AddressZipCodeValidation(shippingData);
      if (isIndirectStoresEnabled()) {
        const storeType = shippingData?.direct === 'Y' && shippingData?.businessName?.toLowerCase() === 'verizon wireless' ? VCS : VAR;
        return {
          ...commonProps,
          id: 'ispuOptionBox',
          text: shippingData?.storeName,
          subtext: parse(`${storeType} <br> ${storeAddress} <br> ${shippingData?.distance} Miles`),
          // subtextRight: Number.isNaN(shippingData.shippingCost) ? PRICE_ZERO : `$${parseFloat(shippingData.shippingCost).toFixed(2)}`,
        };
      }
      return {
        ...commonProps,
        id: 'ispuOptionBox',
        text: shippingData.storeName,
        subtext: parse(`${storeAddress} <br> ${shippingData?.distance} Miles`),
        // subtextRight: Number.isNaN(shippingData.shippingCost) ? PRICE_ZERO : `$${parseFloat(shippingData.shippingCost).toFixed(2)}`,
      };
    }
    return {
      ...commonProps,
      text: shippingData.shippingDescription,
      subtext: shippingData.estimatedDeliveryDateText,
      subtextRight: Number.isNaN(shippingData.shippingCost) ? PRICE_ZERO : `$${parseFloat(shippingData.shippingCost).toFixed(2)}`,
    };
  };

  const modalChanged = (value) => {
    settermsAndConditionsModalVisible(value);
    const obj = { detail: '5GTermsAndConditionsModal', selector: 'termsAndConditionsModalID' };
    eventDispatcher('closeView', obj);
  };

  const toggleShippingOptions = () => {
    setIsIspuDisplay((prevState) => !prevState);
  };

  const closeTermsAndConditionModal = (e) => {
    e.preventDefault();
    settermsAndConditionsModalVisible(false);
  };

  const showTermsAndConditionsModal = (e) => {
    e.preventDefault();
    settermsAndConditionsModalVisible(true);
    const obj = {
      name: '5GTermsAndConditionsModal',
      selector: 'termsAndConditionsModalID',
    };
    eventDispatcher('openView', obj);
  };

  const onSelectShippingType = (e, isISPUStoreSelectedFromTab, firstTwoStoresNearby) => {
    // console.log("ONSELECT", firstTwoStoresNearby);
    // debugger;
    e.target.setAttribute('data-track', 'free in-store pickup');
    try {
      if (e) {
        e.preventDefault();
      }
      // const [lineObject] = this.props.shippingInfoDetails?.lines;
      let selectedShipping;
      const cartData = props?.getCheckOutDetailsState?.lineDetails?.lineInfo?.newLine1?.serviceInfo?.selectedFeaturesList?.visFeature?.filter((obj) =>
        obj?.categoryCodes?.[0]?.toLowerCase()?.includes('whwplus'),
      );

      if (!isISPUStoreSelectedFromTab) {
        selectedShipping = props.shipmentNewLine?.shippingOptions?.find((optionRef) => optionRef.shippingOptionId === e.target?.value);
        props.selectedShippingOptionValue(selectedShipping.shippingOptionId);

        props.saveSelectedOption(selectedShipping);
      } else {
        // debugger;
        selectedShipping = ispuObjForRedesign?.find((optionRef) => optionRef.shippingOptionId === e.target?.value);
        props.selectedShippingOptionValue(selectedShipping.shippingOptionId);

        props.saveSelectedOption(selectedShipping);
      }

      if (selectedShipping.shippingOptionId !== 'ISPU' && !isISPUStoreSelectedFromTab) {
        setselectedSlotId(selectedShipping.shippingOptionId);
        props.changeDivToPickUp(false);
      } else if (
        (isISPUStoreSelectedFromTab && (selectedShipping.shippingOptionId === 'ISPU1' || 'ISPU0')) ||
        (isISPUStoreSelectedFromTab && selectedShipping.shippingOptionId === 'ISPU')
      ) {
        // API call for ISPU store seelction from top two stores
        // alert('HELLO')
        let storeArrayNumberFromListValue;
        let selectedStoreFromList;
        const itemNotAvailbleFromISPUFromModel = selectedShipping.shippingOptionId !== 'ISPU';
        if (itemNotAvailbleFromISPUFromModel) {
          storeArrayNumberFromListValue = selectedShipping.shippingOptionId.slice(-1);
          setStoreArrayNumberFromList(storeArrayNumberFromListValue);
          selectedStoreFromList = firstTwoStoresNearby?.[selectedShipping.shippingOptionId.slice(-1)];
        } else {
          selectedStoreFromList = firstTwoStoresNearby?.[0];
        }

        console.log('selectedStoreFromList', selectedStoreFromList);
        let netaceLocationCode;
        if (itemNotAvailbleFromISPUFromModel) {
          // eslint-disable-next-line prefer-destructuring
          netaceLocationCode = selectedStoreFromList.netaceLocationCode;
        } else {
          netaceLocationCode = selectedStoreFromList.locationCode;
        }

        if (isWHWPhase2Flag() && cartData?.length > 0) {
          store.dispatch({ type: 'EXPRESS_STORE_SELECTED', response: selectedStoreFromList });
        } else {
          // console.log()
          const storeAddress = AddressZipCodeValidation(selectedStoreFromList);
          props.updateISPUShippingOption({
            homePhoneAdded: false,
            locationCode: netaceLocationCode,
            purchasePath: props.purchasePath,
            lineLevelShipment: false,
            cradleResponseDetails: props.cradleResponseDetails,
            lineLevelShipmentSelectedLineSequenceNumber: '',
            storeInfo: {
              storeName: selectedStoreFromList?.storeName || '',
              storeAddress: storeAddress || '',
              zipcode: selectedStoreFromList?.zipcode || '',
              distance: selectedStoreFromList?.distance || '',
              businessName: selectedStoreFromList?.businessName || '',
            },
          });
        }
      } else {
        store.dispatch({ type: 'SET_ISPU_MODAL' });
        // this.setState((prevState) => ({
        setselectionBeforeISPU(prevSelectionBeforeISPU);
        setselectedSlotId(selectedShipping.shippingOptionId);
        // }));
        const obj = {
          name: 'openIspuModal',
          selector: 'openIspuModalID',
        };
        eventDispatcher('openView', obj);
      }
      if (selectedShipping.shippingOptionId !== 'SDD_SAMEDAY' && selectedShipping.shippingOptionId !== 'ISPU' && !isISPUStoreSelectedFromTab) {
        const deliveryDate = new Date(selectedShipping.estimatedDeliveryDate);
        const deliveryDate1 = `${deliveryDate.getMonth() + 1}/${deliveryDate.getDate()}/${deliveryDate.getFullYear()}`;
        saveItemToStore('deliveryDate', deliveryDate1);
        const homePhoneAdded = false;

        props.buildShippingOptionsInput(selectedShipping, null, null, homePhoneAdded, true);
      }
    } catch (error) {
      // TODO notify/log
      console.log(error);
    }
  };

  return (
    <>
      {isMobile && (
        <Margin top="20px">
          <Line type="secondary" surface="light" />
        </Margin>
      )}
      <Margin top={isMobile ? '23px' : '12px'} bottom="40px">
        <TextLink
          type="standAlone"
          surface="light"
          disabled={false}
          onClick={showTermsAndConditionsModal}
          analyticstrack="5G-open-Shipping-Options-Modal"
          aria-label="Learn more about shipping options"
          data-track='{"type": "link", "name": "learnAboutModal"}'
        >
          Learn more about shipping options
        </TextLink>
      </Margin>

      <Margin top="20px">
        {!isShippingTabEnabled() && props.shipmentNewLine?.shippingOptions && (
          <Margin top="30px">
            <RadioBoxGroup
              {...optionsGroupProp}
              orientation="vertical"
              data={final.map((shipping, id) => getOptionData(shipping, id))}
              onChange={(event) => onSelectShippingType(event)}
            />
          </Margin>
        )}

        {isShippingTabEnabled() && props.shipmentNewLine?.shippingOptions && (
          <ShippingTabSection
            selectedSlotId={selectedSlotId}
            isISPUselected={props.shippingStoreInfo?.storeName}
            ISPUSelectedStoreFromModel={props.ISPUSelectedStoreFromModel}
            ISPUStoresClick={ISPUStoresClick}
            dataSelectedFromISPUModel={props.dataSelectedFromISPUModel}
            // isThrottled={isThrottled}
            isFastestStore={isFastestStore}
            final={final}
            shippingOptions={props.shipmentNewLine?.shippingOptions}
            isMobile={isMobile}
            // ShippingOptionsGroup={ShippingOptionsGroup}
            ispuObjForRedesign={ispuObjForRedesign}
            toggleTileTop={toggleTileTop}
            firstTwoStoresNearBy={firstTwoStoresNearBy}
            onSelectShippingType={onSelectShippingType}
            getOptionData={getOptionData}
            changePageBottomDivToPickup={changePageBottomDivToPickup}
            defaultValue={defaultValue}
            optionsGroupProp={optionsGroupProp}
          />
        )}

        {props.isISPUEligible && !isShippingTabEnabled() && !ispuSelected && (
          <Margin top={isMobile ? '23px' : '12px'}>
            <TextLink
              type="standAlone"
              surface="light"
              disabled={false}
              onClick={toggleShippingOptions}
              aria-label={isIspuDisplay ? 'Less Shipping options' : 'More Shipping options'}
              data-track={isIspuDisplay ? 'shipping|Less options' : 'shipping|More options'}
            >
              {isIspuDisplay ? 'Less options' : 'More options'}
            </TextLink>
          </Margin>
        )}

        <Margin top={isMobile ? '41px' : '33px'} bottom={isMobile ? '31px' : '40px'}>
          <Line type="secondary" surface="light" />
        </Margin>
      </Margin>
      {termsAndConditionsModalVisible && (
        <div className="shippingSeeDetailsModal">
          <ShippingPinModal
            ariaLabel="pin modal"
            opened={termsAndConditionsModalVisible}
            onOpenedChange={modalChanged}
            // modalTitle={this.props.SHOP_5G_SHIPPING_MODAL_HEADING}
            modalBody={
              <>
                <ShippingDetailsWrapper>{parse(props.shop_5G_SHIPPING_MODAL_CONTENT_VDS_UPG || '')}</ShippingDetailsWrapper>
                {isMobile && (
                  <Row className="seeDetailsStyle">
                    <Button width="100%" onClick={closeTermsAndConditionModal}>
                      Close
                    </Button>
                  </Row>
                )}
              </>
            }
          />
        </div>
      )}
    </>
  );
};

ShippingOptions.propTypes = {
  shippingInfoDetails: PropTypes.object,
  shop_5G_SHIPPING_MODAL_CONTENT: PropTypes.string,
  selectedShippingOption: PropTypes.array,
  selectedValue: PropTypes.string,
  selectedShippingOptionValue: PropTypes.func,
  saveSelectedOption: PropTypes.func,
  cartDetails: PropTypes.object,
  defaultSelectedSlot: PropTypes.string,
  shippingOption: PropTypes.object,
  buildShippingOptionsInput: PropTypes.func,
  updateStoreListValue: PropTypes.func,
  sddSlotsData: PropTypes.func,
  shippingAddress: PropTypes.object,
  shippingInfoState: PropTypes.object,
  notifyMessage: PropTypes.string,
  shippingHeader: PropTypes.string,
  estimatedDeliveryDate: PropTypes.any,
  openISPUModal: PropTypes.bool,
  shop_5G_SHIPPING_MODAL_CONTENT_VDS_UPG: PropTypes.string,
  showErrorNotification: PropTypes.any,
  getCheckOutDetailsState: PropTypes.any,
  defaultValue: PropTypes.any,
  storeLists: PropTypes.array,
  fastestBadge: PropTypes.string,
  inStockText: PropTypes.string,
  milesValue: PropTypes.any,
  storeListUpdatedValue: PropTypes.any,
  shipmentNewLine: PropTypes.object,
  shippingStoreInfo: PropTypes.object,
  itemAvailableStores: PropTypes.array,
  changeDivToPickUp: PropTypes.any,
  cradleResponseDetails: PropTypes.any,
  isISPUEligible: PropTypes.bool,
  updateISPUShippingOption: PropTypes.any,
  purchasePath: PropTypes.any,
  dataSelectedFromISPUModel: PropTypes.any,
  ISPUSelectedStoreFromModel: PropTypes.object,
  ISPUSelect: PropTypes.any,
  selectOtherOption: PropTypes.bool,
};

export default React.memo(ShippingOptions);
